export const appCourseSearchSorting = {
    create: function(){
        var that = this;
        if($('.js-csr-sorting-dropdown').length){
            that.bindEvents();
        }
    },
    bindEvents: function(){
        var that = this;
        $(document).on('focusin', '.js-csr-sorting-dropdown', function(){
            $(this).attr('data-state', 'expanded');
            $(this).find('.js-csr-sorting-option').each(function(){
                $(this).attr('tabindex', '0');
            });
        });
        $(document).on('focusout', '.js-csr-sorting-dropdown', function(){
            var ddSelected = $(this).find('.js-csr-sorting-dd'),
                hasValue = $(ddSelected).val().length > 0 ? true : false;
            if(!hasValue){
                $(this).attr('data-state', 'placeholder');
            } else {
                $(this).attr('data-state', 'label');
            }
            $(this).find('.js-csr-sorting-option').each(function(){
                $(this).attr('tabindex', '-1');
            });
        });
        $(document).on('click', '.js-csr-sorting-option', function(e){
            e.preventDefault();
            var selectedValue = $(this).attr('aria-label'),
                selectedCol = $(this).closest('.js-csr-sorting-dropdown'),
                selectedInput = $(selectedCol).find('.js-csr-sorting-dd');
            $(selectedCol).attr('data-state', 'label');
            $(selectedInput).val(selectedValue);
            $(this).blur();
            that.sendSortQuery();
        });
    },
    sendSortQuery: function(){
        var that = this;
        console.log('send sort query');
    }
};